import { Card, CardContent, Grid, Typography } from "@mui/material";
import {
  HeaderList,
  IHeaderListActions,
} from "../../Components/Header/HeaderList";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSSelectField from "../../Components/Select/WSSelect";
import config from "../../Config/clientConfig.json";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSAutocompleteField from "../../Components/AutoComplete/AutoComplete";
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
import WSDateField from "../../Components/DateField/WSDateField";
import {
  callAPI,
  dateFormat,
  Method,
  updateMainHeader,
} from "../../commonFunctions/CommonFunctions";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSButton from "../../Components/Button/WSButton";
import dayjs from "dayjs";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import WSWovenImageList from "../../Components/ImageList/ImageList";
import WSImageSingleViewList from "../../Components/Image/WSImageSingleViewList";
import apiConfig from "../../Config/config.json";

// import { useForm, Controller, useFieldArray } from "react-hook-form";

export const CreateExpense: React.FC<any> = (props) => {
  const { control, register, handleSubmit, setValue, watch } = useForm();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [activityDate, setActivityDate] = useState<any>(undefined);
  const { showMessage } = useSnackbar();
  const navigate = useNavigate();
  const [accountSource, setAccountSource] = useState<any[]>([]);
  const [vendorSourceData, setVendorSourceData] = useState<any[]>([]);
  const [leadSourceData, setLeadSourceData] = useState<any[]>([]);
  const [imageList, setImageList] = useState<any>([]);

  interface CodeItem {
    value: string;
  }
  const {
    fields: codeFields,
    append: codeAppend,
    remove: codeRemove,
    replace: codeReplace, // ✅ add this
  } = useFieldArray({ control, name: "codes" });

  const transformAccount = (res: any) => {
    if (!res?.data) return [];
    return res.data.map((item: any) => ({
      label: `${item.name} (${item.type})`,
      value: item.id,
    }));
  };

  const transFormLead = (data: any) => {
    const optionLeads: Array<any> = [];
    if (data) {
      data.map((item: any) => {
        optionLeads.push({
          label: `${item?.firstName} ${item?.lasttName || ""}`,
          value: item?.id,
        });
      });
    }
    return optionLeads;
  };

  const transFormVendor = (data: any) => {
    const optionVendor: Array<any> = [];
    if (data) {
      data.map((item: any) => {
        optionVendor.push({
          label: `${item?.vendorName}`,
          value: item?.id,
        });
      });
    }
    return optionVendor;
  };

  // Combined initialization: first load sources, then load expense (if editing)
  useEffect(() => {
    const fetchAccountData = async () => {
      const res = await callAPI(
        "Accounts/search",
        Method.POST,
        accountSourceConfig
      );
      if (res?.success && res.data?.length > 0) {
        const formattedAccounts = transformAccount(res);
        setAccountSource(formattedAccounts);
      } else {
        setAccountSource([]);
      }
    };

    const fetchVendorData = async () => {
      const res = await callAPI("vendor/search", Method.POST, vendorSource);
      if (res?.success && res.data?.length > 0) {
        setVendorSourceData(transFormVendor(res.data));
      } else {
        setVendorSourceData([]);
      }
    };

    const fetchLeadData = async () => {
      const res = await callAPI("leads/search", Method.POST, leadSource);
      if (res?.success && res.data?.length > 0) {
        setLeadSourceData(transFormLead(res.data));
      } else {
        setLeadSourceData([]);
      }
    };

    // load sources first, then load expense
    const init = async () => {
      await fetchAccountData();
      await fetchVendorData();
      await fetchLeadData();

      // Now that sources are ready, load expense data (if editing)
      if (id) {
        await loadExpenseForEdit();
      }
    };

    init();
  }, [id]); // only re-run when id changes

  const loadExpenseForEdit = async () => {
    try {
      const response: any = await callAPI(`Expenses`, Method.GET, null, id);
      console.log("response data for edit", response);
      if (response) {
        const expenseData: any = response;
        console.log("expense dt", expenseData);

        setValue("expenseAccountId", expenseData?.expenseAccountId || "");
        setValue("paidThrough", expenseData?.paidThrough || "");
        setValue("expenseType", expenseData?.expenseType || "");
        setValue("amount", expenseData?.amount || "");
        setValue("invoiceNumber", expenseData?.invoiceNumber || "");
        setValue("leadId", expenseData?.leadId || "");
        setValue("taxIncluded", expenseData?.taxIncluded ? "True" : "False");
        setValue("taxExcluded", expenseData?.taxExcluded ? "True" : "False");
        setValue("taxAmount", expenseData?.taxAmount || "");
        setValue("vendorId", expenseData?.vendorId || "");

        setImageList(expenseData.attachFile || "");

        // date - ensure format matches your WSDateField format (DD-MM-YYYY)
        if (expenseData?.date) {
          setValue("date", dateFormat(expenseData.date, "DD-MM-YYYY"));
        } else {
          setValue("date", "");
        }

        setValue("note", expenseData?.note || "");
        console.log("codeas are", expenseData.codes);

        // codes: set as array of { value: string } to match your field names
        if (Array.isArray(expenseData?.codes)) {
          const codesForForm = expenseData.codes.map((c: any) => ({
            value: typeof c === "string" ? c : c?.value ?? "",
          }));
          setValue("codes", codesForForm);
          codeReplace(codesForForm);
        } else {
          setValue("codes", []);
          codeReplace([]);
        }

        const BASE_URL = apiConfig.imgUrl;

const formattedImage =
  typeof expenseData?.attachFile === "string" && expenseData.attachFile
    ? [
        {
          imgUrl: `${BASE_URL}/${expenseData.attachFile.replace(/\\/g, "/")}`,
        },
      ]
    : [];

console.log("🖼️ Image data for list:", formattedImage);
setImageList(formattedImage);

      }
      console.log("edit", response);
    } catch (e) {
      console.error("❌ Error loading expense:", e);
    }
  };

  useEffect(() => {
    updateMainHeader("Add Expense");
    breadCrumbsStore.updateBreadCrumbs([
      { expense: "/expense/list" },
      { [id ? "Edit expense" : "Create expense"]: `` },
    ]);
  }, [id]);

  const handleData = async (data: any) => {
    try {
      setLoading(true);
      const response: any = await saveData(data);
      if (response && response?.message) {
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
        if (response.success === true) {
          navigate(`/expense/list`);
        }
      } else if (response?.id) {
        showMessage("Expense Created Successfully", "success");
        navigate(`/expense/list`);
      }
    } catch (e: any) {
      showMessage(e?.error || "Error saving expense");
    } finally {
      setLoading(false);
    }
  };

  const saveData = async (data: any) => {
    // parse date strictly if in DD-MM-YYYY format
    const formattedDate = dayjs(data.date, "DD-MM-YYYY").format("YYYY-MM-DD");

  const formData = new FormData();
    formData.append("ExpenseAccountId", data?.expenseAccountId || "");
    formData.append("PaidThrough", data?.paidThrough || "");
    formData.append("ExpenseType", data?.expenseType || "");
    formData.append("Amount", data?.amount ? data.amount.toString() : "0");
    formData.append("InvoiceNumber", data?.invoiceNumber || "");
    formData.append("Note", data?.note || "");
    formData.append("LeadId", data?.leadId || "");
    formData.append("TaxIncluded", data?.taxIncluded || "");
    formData.append("TaxExcluded", data?.taxExcluded || "");
    formData.append(
      "TaxAmount",
      data?.taxAmount ? data.taxAmount.toString() : "0"
    );
    formData.append("VendorId", data?.vendorId || "");
    formData.append("Date", formattedDate);

    if (data?.codes?.length) {
      (data.codes as CodeItem[]).forEach((c, i) => {
        formData.append(`Codes[${i}]`, c.value);
      });
    }

    if (data?.attachFile && data.attachFile.length > 0) {
      formData.append("AttachFile", data.attachFile[0]);
    }

    console.log("📦 Final FormData Payload:");
    console.log("📅 date value:", data.date);

    for (const pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

   let response: any;
  if (id) {
    // 🔄 Update existing expense
   response = await callAPI("Expenses", Method.PUT, formData, id, true);
  } else {
    // ➕ Create new expense
    response = await callAPI("Expenses", Method.POST, formData, undefined, true);
  }

  return response;
};

  const accountSourceConfig = {
    url: "Accounts/search",
    page: 1,
    pageSize: 10000000,
    filter: [],
    sort: [],
  };

  const leadSource = {
    url: "leads/search",
    page: 1,
    pageSize: 10000000,
    filter: [],
    sort: [],
  };

  const vendorSource = {
    url: "vendor/search",
    page: 1,
    pageSize: 10000000,
    filter: [],
    sort: [],
  };

  const handleCancelClick = () => {
    navigate(`/expense/list`);
  };

  const actions: IHeaderListActions[] = [
    {
      type: "button",
      text: "Cancel",
      size: "small",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "primary",
    },
    {
      type: "button",
      text: "Save",
      loading: loading,
      size: "small",
      onClick: handleSubmit(handleData),
      buttonType: "submit",
      variant: "outlined",
      color: "primary",
    },
  ];
  // 🗑️ Function to remove image
  const handleRemoveImage = () => {
    setImageList([]); // remove the current image from state
  };

  return (
    <Grid>
      <HeaderList
        title={!id ? "Create expense" : "Update expense"}
        type="card"
        position="relative"
        actions={actions}
        isBackButton={true}
        url="/expense/list"
      />
      <Card>
        <CardContent>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"} sx={{ fontSize: ".9rem" }}>
                  Expense Information
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSAutocompleteField
                  id="expenseAccountId"
                  label="Expense Account"
                  options={accountSource}
                  control={control}
                  name="expenseAccountId"
                  rules={{ required: true }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSSelectField
                  options={config.paidThroughConfig.staticOptionData}
                  rules={{ required: true }}
                  {...register("paidThrough")}
                  id="paidThrough"
                  control={control}
                  label="Paid Through"
                  name="paidThrough"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSSelectField
                  options={[
                    { label: "Service", value: "service" },
                    { label: "Product", value: "product" },
                    { label: "Travel", value: "travel" },
                    { label: "Miscellaneous", value: "misc" },
                  ]}
                  rules={{ required: true }}
                  {...register("expenseType")}
                  id="expenseType"
                  control={control}
                  label="Expense Type"
                  name="expenseType"
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <WSTextField
                  label={"InvoiceNumber"}
                  {...register("invoiceNumber")}
                  id="invoiceNumber"
                  name="invoiceNumber"
                  control={control}
                  type={"text" as any}
                  rules={{ required: false }}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <WSTextField
                  label={"Amount"}
                  {...register("amount")}
                  id="amount"
                  name="amount"
                  control={control}
                  type={"text" as any}
                  rules={{ required: true }}
                />
              </Grid>

              <Grid item xs={12}>
                <WSTextAreaField
                  label={"Notes"}
                  {...register("note")}
                  id="note"
                  name="note"
                  control={control}
                  rows={2}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSAutocompleteField
                  source={leadSource}
                  rules={{ required: true }}
                  {...register("leadId")}
                  id="leadId"
                  transFormData={transFormLead}
                  control={control}
                  label="Lead"
                  name="leadId"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSSelectField
                  options={config.trueorfalseConfig.staticOptionData}
                  rules={{ required: true }}
                  {...register("taxIncluded")}
                  id="taxIncluded"
                  control={control}
                  label="Tax Included"
                  name="taxIncluded"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSSelectField
                  options={config.trueorfalseConfig.staticOptionData}
                  rules={{ required: true }}
                  {...register("taxExcluded")}
                  id="taxExcluded"
                  control={control}
                  label="Tax Excluded"
                  name="taxExcluded"
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <WSTextField
                  label={"Tax Amount"}
                  {...register("taxAmount")}
                  id="taxAmount"
                  name="taxAmount"
                  control={control}
                  type={"text" as any}
                  rules={{ required: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSAutocompleteField
                  source={vendorSource}
                  rules={{ required: true }}
                  {...register("vendorId")}
                  id="vendorId"
                  transFormData={transFormVendor}
                  control={control}
                  label="Vendor"
                  name="vendorId"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSDateField
                  dateFormat={"DD-MM-YYYY"}
                  label={"Date"}
                  id="date"
                  defaultValue={dateFormat(activityDate, "DD-MM-YYYY")}
                  setValue={setValue}
                  name="date"
                  control={control}
                  rules={{ required: true }}
                  denyFuturOrPast="past"
                />
              </Grid>
              <React.Fragment key={"ss"}>
                <Grid
                  item
                  sm={12}
                  xs={12}
                  display="flex"
                  justifyContent="left"
                >
                  {imageList && imageList.length > 0 && (
                    <div
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <img
                        src={imageList[0].imgUrl}
                        alt="Expense File"
                        style={{
                          width: "180px", // ✅ smaller image
                          height: "auto",
                          borderRadius: "10px",
                          objectFit: "cover",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        }}
                      />

                      {/* 🗑️ Delete button overlay */}
                      <WSIcons.DeleteIcon
                        onClick={() => handleRemoveImage()}
                        sx={{
                          position: "absolute",
                          top: 5,
                          right: 5,
                          color: "red",
                          backgroundColor: "white",
                          borderRadius: "50%",
                          cursor: "pointer",
                          fontSize: "1.2rem",
                          boxShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                        }}
                      />
                    </div>
                  )}
                </Grid>
              </React.Fragment>
              <Grid item xs={12} sm={6}>
                <WSFileUpload
                  label="Attach Files"
                  id="attachFile"
                  name="attachFile"
                  control={control}
                  rules={{ required: false }}
                  acceptFileTypes=".jpg,.jpeg,.png,.pdf"
                  maxFileSizeMB={10}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography
                  sx={{ fontSize: "0.875rem", fontWeight: "bold" }}
                  mt={2}
                  ml={2}
                >
                  Codes
                </Typography>

                {codeFields.map((row, index) => (
                  <Grid
                    container
                    spacing={2}
                    key={row.id}
                    alignItems="center"
                    mt={1}
                    ml={1}
                  >
                    <Grid item xs={6}>
                      <WSTextField
                        label={`Code ${index + 1}`}
                        {...register(`codes.${index}.value` as const)}
                        id={`codes-value-${index}`}
                        control={control}
                      />
                    </Grid>

                    <Grid item display="flex" justifyContent="center">
                      <WSIcons.DeleteIcon
                        onClick={() => codeRemove(index)}
                        sx={{ color: "red", cursor: "pointer" }}
                      />
                    </Grid>
                  </Grid>
                ))}
                <br></br>

                <WSButton
                  id="addCodeButton"
                  label="+ Add String Item"
                  size="small"
                  sx={{ fontSize: "0.875rem" }}
                  onClick={() => codeAppend({ value: "" })}
                />
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Grid>
  );
};
